export default __webpack_public_path__ + "static/media/image.less-taxi.4f675dac.png";